import React, { useState } from 'react';
import { Button } from './ui/Button';
import { Send, CheckCircle, AlertCircle, Loader2 } from 'lucide-react';
export function PartnersSection() {
  const [formData, setFormData] = useState({
    organization: '',
    contactPerson: '',
    email: '',
    phone: '',
    partnershipType: 'Бізнес-партнерство',
    message: ''
  });
  const [status, setStatus] = useState<'idle' | 'submitting' | 'success' | 'error'>('idle');
  const handleChange = (e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement | HTMLSelectElement>) => {
    const {
      name,
      value
    } = e.target;
    setFormData(prev => ({
      ...prev,
      [name]: value
    }));
  };
  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    setStatus('submitting');
    try {
      const response = await fetch('https://formsubmit.co/ajax/fgsukraine@gmail.com', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          Accept: 'application/json'
        },
        body: JSON.stringify({
          ...formData,
          _subject: `Нова заявка на партнерство від ${formData.organization}`,
          _captcha: 'false'
        })
      });
      if (response.ok) {
        setStatus('success');
        setFormData({
          organization: '',
          contactPerson: '',
          email: '',
          phone: '',
          partnershipType: 'Бізнес-партнерство',
          message: ''
        });
      } else {
        setStatus('error');
      }
    } catch (error) {
      setStatus('error');
    }
  };
  return <section id="partners" className="py-20 bg-[#F5F0E8]" data-id="element-396">
      <div className="container mx-auto px-4" data-id="element-397">
        <div className="text-center mb-12" data-id="element-398">
          <h2 className="text-3xl md:text-4xl font-serif font-bold text-[#0A5E5C] mb-4" data-id="element-399">
            Приєднуйся до Простору Чесної Гри у якості Партнера
          </h2>
          <div className="h-1 w-24 bg-[#D4A843] mx-auto rounded-full mb-6" data-id="element-400" />
          <p className="text-gray-600 text-lg max-w-2xl mx-auto" data-id="element-401">
            Заповніть форму, і ми зв'яжемося з вами для обговорення партнерства
          </p>
        </div>

        <div className="max-w-2xl mx-auto bg-white rounded-xl shadow-lg p-8 md:p-10 border border-gray-100" data-id="element-402">
          {status === 'success' ? <div className="text-center py-12 animate-fade-in" data-id="element-403">
              <div className="w-20 h-20 bg-green-100 rounded-full flex items-center justify-center mx-auto mb-6" data-id="element-404">
                <CheckCircle className="w-10 h-10 text-green-600" data-id="element-405" />
              </div>
              <h3 className="text-2xl font-serif font-bold text-[#0A5E5C] mb-4" data-id="element-406">
                Дякуємо за заявку!
              </h3>
              <p className="text-gray-600 text-lg mb-8" data-id="element-407">
                Ми отримали вашу інформацію і зв'яжемося з вами найближчим часом
                для обговорення деталей співпраці.
              </p>
              <Button variant="outline" onClick={() => setStatus('idle')} className="mx-auto" data-id="element-408">
                Надіслати ще одну заявку
              </Button>
            </div> : <form onSubmit={handleSubmit} className="space-y-6" data-id="element-409">
              <div className="grid grid-cols-1 md:grid-cols-2 gap-6" data-id="element-410">
                <div className="space-y-2" data-id="element-411">
                  <label htmlFor="organization" className="block text-sm font-medium text-[#0A5E5C]" data-id="element-412">
                    Назва організації
                  </label>
                  <input type="text" id="organization" name="organization" required value={formData.organization} onChange={handleChange} className="w-full px-4 py-3 rounded-lg border border-gray-200 focus:border-[#0A5E5C] focus:ring-2 focus:ring-[#0A5E5C]/20 outline-none transition-all" placeholder="Ваша компанія" data-id="element-413" />
                </div>

                <div className="space-y-2" data-id="element-414">
                  <label htmlFor="contactPerson" className="block text-sm font-medium text-[#0A5E5C]" data-id="element-415">
                    Контактна особа
                  </label>
                  <input type="text" id="contactPerson" name="contactPerson" required value={formData.contactPerson} onChange={handleChange} className="w-full px-4 py-3 rounded-lg border border-gray-200 focus:border-[#0A5E5C] focus:ring-2 focus:ring-[#0A5E5C]/20 outline-none transition-all" placeholder="Ім'я та Прізвище" data-id="element-416" />
                </div>
              </div>

              <div className="grid grid-cols-1 md:grid-cols-2 gap-6" data-id="element-417">
                <div className="space-y-2" data-id="element-418">
                  <label htmlFor="email" className="block text-sm font-medium text-[#0A5E5C]" data-id="element-419">
                    Email
                  </label>
                  <input type="email" id="email" name="email" required value={formData.email} onChange={handleChange} className="w-full px-4 py-3 rounded-lg border border-gray-200 focus:border-[#0A5E5C] focus:ring-2 focus:ring-[#0A5E5C]/20 outline-none transition-all" placeholder="email@example.com" data-id="element-420" />
                </div>

                <div className="space-y-2" data-id="element-421">
                  <label htmlFor="phone" className="block text-sm font-medium text-[#0A5E5C]" data-id="element-422">
                    Телефон
                  </label>
                  <input type="tel" id="phone" name="phone" required value={formData.phone} onChange={handleChange} className="w-full px-4 py-3 rounded-lg border border-gray-200 focus:border-[#0A5E5C] focus:ring-2 focus:ring-[#0A5E5C]/20 outline-none transition-all" placeholder="+38 (0XX) XXX-XX-XX" data-id="element-423" />
                </div>
              </div>

              <div className="space-y-2" data-id="element-424">
                <label htmlFor="partnershipType" className="block text-sm font-medium text-[#0A5E5C]" data-id="element-425">
                  Тип партнерства
                </label>
                <div className="relative" data-id="element-426">
                  <select id="partnershipType" name="partnershipType" value={formData.partnershipType} onChange={handleChange} className="w-full px-4 py-3 rounded-lg border border-gray-200 focus:border-[#0A5E5C] focus:ring-2 focus:ring-[#0A5E5C]/20 outline-none transition-all appearance-none bg-white" data-id="element-427">
                    <option value="Бізнес-партнерство" data-id="element-428">
                      Бізнес-партнерство
                    </option>
                    <option value="Медіа-партнерство" data-id="element-429">Медіа-партнерство</option>
                    <option value="Освітнє партнерство" data-id="element-430">
                      Освітнє партнерство
                    </option>
                    <option value="Інше" data-id="element-431">Інше</option>
                  </select>
                  <div className="absolute inset-y-0 right-0 flex items-center px-4 pointer-events-none text-gray-500" data-id="element-432">
                    <svg className="w-4 h-4 fill-current" viewBox="0 0 20 20" data-id="element-433">
                      <path d="M5.293 7.293a1 1 0 011.414 0L10 10.586l3.293-3.293a1 1 0 111.414 1.414l-4 4a1 1 0 01-1.414 0l-4-4a1 1 0 010-1.414z" clipRule="evenodd" fillRule="evenodd" data-id="element-434"></path>
                    </svg>
                  </div>
                </div>
              </div>

              <div className="space-y-2" data-id="element-435">
                <label htmlFor="message" className="block text-sm font-medium text-[#0A5E5C]" data-id="element-436">
                  Повідомлення
                </label>
                <textarea id="message" name="message" rows={4} value={formData.message} onChange={handleChange} className="w-full px-4 py-3 rounded-lg border border-gray-200 focus:border-[#0A5E5C] focus:ring-2 focus:ring-[#0A5E5C]/20 outline-none transition-all resize-none" placeholder="Розкажіть коротко про вашу пропозицію..." data-id="element-437"></textarea>
              </div>

              {status === 'error' && <div className="flex items-center gap-2 text-red-600 bg-red-50 p-4 rounded-lg border border-red-100" data-id="element-438">
                  <AlertCircle className="w-5 h-5 flex-shrink-0" data-id="element-439" />
                  <p className="text-sm" data-id="element-440">
                    Виникла помилка при відправці форми. Будь ласка, спробуйте
                    ще раз.
                  </p>
                </div>}

              <Button type="submit" variant="primary" size="lg" className="w-full flex items-center justify-center gap-2" disabled={status === 'submitting'} data-id="element-441">
                {status === 'submitting' ? <>
                    <Loader2 className="w-5 h-5 animate-spin" data-id="element-442" />
                    Відправка...
                  </> : <>
                    <Send className="w-5 h-5" data-id="element-443" />
                    Надіслати заявку
                  </>}
              </Button>

              <p className="text-xs text-center text-gray-500 mt-4" data-id="element-444">
                Натискаючи кнопку, ви погоджуєтесь на обробку персональних даних
              </p>
            </form>}
        </div>
      </div>
    </section>;
}